import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";

const PLAN_DETAILS = {
  essencial: {
    id: "essencial",
    name: "Essencial",
    price: "Desde 150â‚¬",
    summary: "Presenca online simples e profissional.",
    intro:
      "Plano para lancar um site rapido, claro e focado em contactos. Ideal para comecar sem excesso de complexidade.",
    quickStats: [
      { label: "Paginas", value: "1 pagina" },
      { label: "Revisoes", value: "1 ronda" },
      { label: "Prazo medio", value: "5-7 dias uteis" },
      { label: "Suporte pos-lancamento", value: "7 dias" },
    ],
    idealFor: [
      "Profissionais independentes",
      "Negocios locais que precisam de presenca digital basica",
      "Projetos em fase inicial",
    ],
    included: [
      {
        title: "Estrutura one-page",
        detail:
          "Secoes essenciais: abertura, servicos, sobre, prova social e contacto.",
      },
      {
        title: "Design personalizado",
        detail:
          "Visual adaptado a identidade da marca com foco em clareza e leitura.",
      },
      {
        title: "Formulario de contacto",
        detail:
          "Formulario funcional com envio para email e CTA para contacto rapido.",
      },
      {
        title: "SEO base + mapa",
        detail:
          "Titulos, meta descricao, estrutura inicial de SEO e integracao de Google Maps.",
      },
      {
        title: "Publicacao",
        detail:
          "Preparacao final para publicacao e checklist tecnico antes de entrega.",
      },
    ],
    limits: [
      "Ate 5 secoes de conteudo",
      "1 idioma",
      "1 formulario",
      "Sem area de membros e sem ecommerce",
    ],
    notIncluded: [
      "Criacao de logotipo",
      "Producao fotografica ou video",
      "Redacao completa de todos os textos",
      "Traducoes para outros idiomas",
    ],
    addons: [
      "Pagina extra: +70â‚¬",
      "Copywriting completo: +90â‚¬",
      "Plano de manutencao mensal: +35â‚¬/mes",
    ],
    timeline: [
      {
        phase: "Dia 1",
        title: "Briefing",
        detail: "Alinhamento de objetivos, referencias e estrutura do site.",
      },
      {
        phase: "Dias 2-3",
        title: "Design",
        detail: "Criacao do visual base e validacao da direcao grafica.",
      },
      {
        phase: "Dias 4-6",
        title: "Desenvolvimento",
        detail: "Implementacao da pagina, formulario e otimizacao essencial.",
      },
      {
        phase: "Dia 7",
        title: "Revisao e entrega",
        detail: "Ajustes finais, publicacao e envio do material de apoio.",
      },
    ],
    faq: [
      {
        q: "Posso adicionar mais secoes depois?",
        a: "Sim. Podes evoluir para secoes ou paginas extras em qualquer momento.",
      },
      {
        q: "Inclui dominio e alojamento?",
        a: "Nao. Podemos recomendar e ajudar na configuracao sem problema.",
      },
      {
        q: "Posso migrar para o plano Negocio?",
        a: "Sim. O projeto pode ser expandido para o plano seguinte.",
      },
    ],
  },
  negocio: {
    id: "negocio",
    name: "Negocio",
    price: "Desde 350â‚¬",
    summary: "Estrutura completa para empresas com foco em conversao.",
    intro:
      "Plano para marcas que precisam de mais contexto, paginas estrategicas e um fluxo claro para gerar pedidos.",
    quickStats: [
      { label: "Paginas", value: "Ate 6 paginas" },
      { label: "Revisoes", value: "2 rondas" },
      { label: "Prazo medio", value: "10-15 dias uteis" },
      { label: "Suporte pos-lancamento", value: "15 dias" },
    ],
    idealFor: [
      "Empresas de servicos",
      "Negocios em crescimento",
      "Marcas que precisam de mais credibilidade online",
    ],
    included: [
      {
        title: "Arquitetura de paginas",
        detail:
          "Estrutura completa com Home, Servicos, Sobre, Contacto e paginas adicionais.",
      },
      {
        title: "Copy base orientado a conversao",
        detail:
          "Textos base para blocos principais com foco em proposta de valor e CTA.",
      },
      {
        title: "Integracoes de contacto",
        detail:
          "WhatsApp, redes sociais e formulario com encaminhamento para email.",
      },
      {
        title: "Performance + SEO on-page",
        detail:
          "Otimizacao de carregamento, estrutura semantica e boas praticas de indexacao.",
      },
      {
        title: "Publicacao e configuracao",
        detail:
          "Entrega com site pronto para operar e orientacao final de utilizacao.",
      },
    ],
    limits: [
      "Ate 6 paginas principais",
      "Ate 2 formularios",
      "1 idioma",
      "Sem sistema de area privada",
    ],
    notIncluded: [
      "CRM complexo ou automacoes avancadas",
      "Area de cliente com login",
      "Integracoes custom complexas com sistemas externos",
      "Gestao continua de campanhas pagas",
    ],
    addons: [
      "Pagina adicional: +60â‚¬ por pagina",
      "Blog com estrutura inicial: +120â‚¬",
      "Integracao de agenda online: +90â‚¬",
    ],
    timeline: [
      {
        phase: "Dias 1-2",
        title: "Levantamento",
        detail: "Briefing, objetivos de negocio e mapa de paginas.",
      },
      {
        phase: "Dias 3-5",
        title: "UX e layout",
        detail: "Definicao da estrutura de cada pagina e proposta visual.",
      },
      {
        phase: "Dias 6-12",
        title: "Desenvolvimento",
        detail: "Implementacao completa com integracoes e ajustes.",
      },
      {
        phase: "Dias 13-15",
        title: "Validacao e lancamento",
        detail: "Revisoes finais, testes e publicacao.",
      },
    ],
    faq: [
      {
        q: "Consigo editar os textos depois?",
        a: "Sim. O projeto e entregue com estrutura para atualizacoes simples.",
      },
      {
        q: "Este plano da para reservas ou pedidos?",
        a: "Sim, atraves de formulario, WhatsApp e fluxos de contacto dedicados.",
      },
      {
        q: "Posso comecar com este plano e virar loja?",
        a: "Sim. A evolucao para Loja Online e possivel a qualquer momento.",
      },
    ],
  },
  "loja-online": {
    id: "loja-online",
    name: "Loja Online",
    price: "Desde 650â‚¬",
    summary: "Base completa para catalogo online com operacao simples.",
    intro:
      "Plano orientado para catalogo online, com produtos, pedidos de contacto e regras de envio prontos para operar.",
    quickStats: [
      { label: "Estrutura", value: "Loja + paginas base" },
      { label: "Revisoes", value: "2 rondas" },
      { label: "Prazo medio", value: "15-25 dias uteis" },
      { label: "Suporte pos-lancamento", value: "20 dias" },
    ],
    idealFor: [
      "Lojas fisicas que querem vender online",
      "Marcas com catalogo de produtos",
      "Projetos focados em catalogo e operacao diaria",
    ],
    included: [
      {
        title: "Catalogo e navegacao",
        detail:
          "Categorias, pagina de produto, filtros base e experiencia de navegacao organizada.",
      },
      {
        title: "Pedidos e contacto",
        detail:
          "Fluxo de pedido por formulario e WhatsApp com validacoes e experiencia mobile responsiva.",
      },
      {
        title: "Envios e organizacao",
        detail:
          "Configuracao inicial de envios, regras base de entrega e estrutura operacional.",
      },
      {
        title: "Gestao da loja",
        detail:
          "Painel para gerir produtos, stock, encomendas e conteudos principais.",
      },
      {
        title: "Formacao inicial",
        detail:
          "Sessao de onboarding para gestao diaria da operacao da loja.",
      },
    ],
    limits: [
      "Configuracao inicial para ate 30 produtos",
      "Ate 2 canais de pedido/contato na fase inicial",
      "1 idioma",
      "Sem ERP avancado no pacote base",
    ],
    notIncluded: [
      "Custos de plataforma e servicos de terceiros",
      "Integracoes ERP/CRM avancadas",
      "Campanhas de anuncios (Meta/Google)",
      "Fotografia profissional de produtos",
    ],
    addons: [
      "Carga adicional de produtos: +80â‚¬ por bloco de 25",
      "Automacao de follow-up por email: +110€",
      "Modulo de campanhas sazonais: +90€",
    ],
    timeline: [
      {
        phase: "Dias 1-3",
        title: "Planeamento",
        detail: "Estrutura da loja, categorias e regras comerciais iniciais.",
      },
      {
        phase: "Dias 4-9",
        title: "Implementacao tecnica",
        detail: "Catalogo, pedidos de contacto e envios.",
      },
      {
        phase: "Dias 10-18",
        title: "Conteudo e testes",
        detail: "Produtos iniciais, testes de navegacao e ajustamentos.",
      },
      {
        phase: "Dias 19-25",
        title: "Launch",
        detail: "Validacao final, abertura da loja e formacao.",
      },
    ],
    faq: [
      {
        q: "Consigo gerir produtos sem programar?",
        a: "Sim. A loja e preparada para gestao simples no dia a dia.",
      },
      {
        q: "Posso vender produtos fisicos e digitais?",
        a: "Sim, desde que seja definido no levantamento inicial.",
      },
      {
        q: "Tem suporte depois do lancamento?",
        a: "Sim. O plano inclui suporte inicial para estabilizacao da operacao.",
      },
    ],
  },
};

export default function PlanDetail() {
  const { planId } = useParams();
  const plan = planId ? PLAN_DETAILS[planId.toLowerCase()] : null;

  if (!plan) {
    return (
      <main
        className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6"
        data-testid="plan-detail-not-found"
      >
        <div className="max-w-xl text-center space-y-5">
          <p className="text-sm font-semibold tracking-wide uppercase text-teal-700">Plano</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900">
            Opcao nao encontrada
          </h1>
          <p className="text-lg text-slate-600">
            Este plano nao existe ou foi movido.
          </p>
          <Link
            to="/#orcamentos"
            className="inline-flex items-center justify-center rounded-full bg-teal-700 px-6 py-3 font-medium text-white transition-colors hover:bg-teal-800"
          >
            Voltar aos planos
          </Link>
        </div>
      </main>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-slate-800" data-testid={`plan-detail-${plan.id}`}>
      <Seo
        title={`${plan.name} | Web & Studio`}
        description={`${plan.summary} ${plan.price}.`}
        path={`/planos/${plan.id}`}
      />

      <main className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-10">
          <Link
            to="/#orcamentos"
            className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-medium"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar aos planos
          </Link>
        </div>

        <section className="rounded-3xl border border-slate-200 bg-white p-8 md:p-12 shadow-sm">
          <p className="text-sm font-medium tracking-wide uppercase text-teal-700">Plano</p>
          <h1 className="mt-3 text-4xl md:text-5xl font-semibold tracking-tight text-slate-900">
            {plan.name}
          </h1>
          <p className="mt-4 text-lg text-slate-600 max-w-3xl">{plan.intro}</p>
          <p className="mt-6 text-3xl font-bold tracking-tight text-slate-900">{plan.price}</p>

          <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {plan.quickStats.map((stat) => (
              <div key={stat.label} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                <p className="text-xs uppercase tracking-wide text-slate-500">{stat.label}</p>
                <p className="mt-1 text-sm font-semibold text-slate-900">{stat.value}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/#contacto"
              className="inline-flex items-center justify-center rounded-full border border-slate-200 px-6 py-3 font-medium text-slate-700 transition-colors hover:bg-slate-50"
              data-testid="plan-detail-contact"
            >
              Falar connosco
            </Link>
          </div>
        </section>

        <div className="mt-8 grid gap-6 lg:grid-cols-2">
          <section className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-semibold text-slate-900">Ideal para</h2>
            <ul className="mt-5 space-y-3">
              {plan.idealFor.map((item) => (
                <li key={item} className="flex items-start gap-2 text-slate-700">
                  <CheckCircle2 className="h-5 w-5 text-teal-700 flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-semibold text-slate-900">Limites do plano</h2>
            <ul className="mt-5 space-y-3">
              {plan.limits.map((item) => (
                <li key={item} className="flex items-start gap-2 text-slate-700">
                  <CheckCircle2 className="h-5 w-5 text-teal-700 flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </div>

        <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
          <h2 className="text-2xl font-semibold text-slate-900">O que recebe neste plano</h2>
          <div className="mt-5 grid gap-4 md:grid-cols-2">
            {plan.included.map((item) => (
              <article key={item.title} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                <h3 className="text-base font-semibold text-slate-900">{item.title}</h3>
                <p className="mt-2 text-sm text-slate-700 leading-relaxed">{item.detail}</p>
              </article>
            ))}
          </div>
        </section>

        <div className="mt-8 grid gap-6 lg:grid-cols-2">
          <section className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-semibold text-slate-900">Nao inclui</h2>
            <ul className="mt-5 space-y-3">
              {plan.notIncluded.map((item) => (
                <li key={item} className="flex items-start gap-2 text-slate-700">
                  <CheckCircle2 className="h-5 w-5 text-teal-700 flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-semibold text-slate-900">Extras opcionais</h2>
            <ul className="mt-5 space-y-3">
              {plan.addons.map((item) => (
                <li key={item} className="flex items-start gap-2 text-slate-700">
                  <CheckCircle2 className="h-5 w-5 text-teal-700 flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </div>

        <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
          <h2 className="text-2xl font-semibold text-slate-900">Cronograma estimado</h2>
          <div className="mt-5 grid gap-3 md:grid-cols-2">
            {plan.timeline.map((item) => (
              <article key={`${item.phase}-${item.title}`} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                <p className="text-xs uppercase tracking-wide text-slate-500">{item.phase}</p>
                <h3 className="mt-1 text-base font-semibold text-slate-900">{item.title}</h3>
                <p className="mt-2 text-sm text-slate-700">{item.detail}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
          <h2 className="text-2xl font-semibold text-slate-900">Perguntas frequentes</h2>
          <div className="mt-5 space-y-3">
            {plan.faq.map((item) => (
              <article key={item.q} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                <h3 className="text-base font-semibold text-slate-900">{item.q}</h3>
                <p className="mt-2 text-sm text-slate-700 leading-relaxed">{item.a}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
